import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', redirectTo: 'connect', pathMatch: 'full' },
    {
        path: 'connect',
        loadComponent: () => import('./features/connect/ui/pages/connect/connect').then((c) => c.Connect),
        loadChildren: () => import('./features/connect/connect-routes').then((route) => route.connectRoutes),
    },
    {
        path: 'error',
        loadComponent: () => import('./features/connect/ui/components/error/error').then((c) => c.Error),
    },
    {
        path: 'not-compatible',
        loadComponent: () => import('./features/connect/ui/components/not-compatible/not-compatible').then((c) => c.NotCompatible),
    },
];
